import { getSupabase } from '../supabase.js';
import type { IdentityProfile } from './types.js';

export type { IdentityProfile } from './types.js';

let cachedProfile: IdentityProfile | null = null;

/**
 * Fetch Tom's identity profile from Supabase.
 * Caches in memory — one API call per page load.
 */
export async function getIdentityProfile(): Promise<IdentityProfile | null> {
  if (cachedProfile) return cachedProfile;

  const supabase = getSupabase();
  const { data, error } = await supabase
    .from('identity_profiles')
    .select('*')
    .eq('user_id', 'tom')
    .single();

  if (error || !data) {
    console.warn('[identity] Failed to fetch profile:', error?.message);
    return null;
  }

  cachedProfile = data as IdentityProfile;
  return cachedProfile;
}

/**
 * Get the cached profile (returns null if not yet fetched).
 * Use this in synchronous contexts after initial fetch.
 */
export function getCachedProfile(): IdentityProfile | null {
  return cachedProfile;
}
